/* eslint semi:0 */
import Carousel from 'nuka-carousel'
import { connect, } from 'react-redux'
import React, { Component, } from 'react'
import reduxMount from '../../jsCore/utils/reduxMounter'
import Navigation from './components/navigation'
import { scheduleActions, } from './scheduleActions'
import { scheduleReducer, } from './scheduleReducer'
import EmptySchedule from './components/emptySchedule'
import { t, } from '../../jsCore/providers/i18nProvider/i18nProvider'
import ShowMoreButton from './components/showMoreButton'
import LeagueSelection from './components/leagueSelection'
import MatchContainer from './components/matchItemHomepage'
import NoUpcomingMatches from './components/noUpcomingMatches'
import { MOUNT_POINTS, } from '../../jsCore/config/preRenderedSelectorsConfig'
import { getNoEndpointsErrorMessage, } from '../../jsCore/application/sagas/fetchSaga'
import {
  isSupportedForDomain, get as getFromPdo,
} from '../../jsCore/application/pageDataObject'
import {
  transformMatchResponseToHomepageSchedule,
} from './scheduleHomepageTransformUtil'
import { getMobileQuery, getTabletQuery, getDesktopQuery, getDesktopWideQuery, } from '../../jsCore/utils/mediaQuery'


const SCHEDULE_FEATURE_ID = 'Schedule'
const STATE_KEY = 'scheduleComponent'
const COMPONENT_NAME = 'ScheduleContainer'
const MATCH_STATUS = {
  FINISHED: 'finished',
}
const NUM_VISIBLE_ITEMS_DESKTOP_WIDE = 3
const MEDIA_QUERY_TO_NUM_ITEMS = [
  { query: getMobileQuery(), items: 1, },
  { query: getTabletQuery(), items: 2, },
  { query: getDesktopQuery(), items: 2, },
  { query: getDesktopWideQuery(), items: NUM_VISIBLE_ITEMS_DESKTOP_WIDE, },
]


let mediaQueryListeners = []

const matchesNotFinishedPredicate = (match) => match.status !== MATCH_STATUS.FINISHED
let scoresUrl = null

function getScoresUrl(){
  return scoresUrl || (
    scoresUrl = getFromPdo('config.pages_path.fixtures_path', 'scores')
  )
}

function createNavigationComponent({
  direction, text: caption, clickHandler: onClick,
}){
  return <Navigation { ...{ direction, caption, onClick, } } />
}

function getMobileLeagueStartOffset(leagueMatches){
  const startOffsetWhenAllIsFinished = leagueMatches.length - 1
  const firstUnfinishedMatchIndex = leagueMatches.findIndex(matchesNotFinishedPredicate)
  return firstUnfinishedMatchIndex === -1 ?
    startOffsetWhenAllIsFinished :
    firstUnfinishedMatchIndex
}

function getLeagueStartOffset(leagueMatches){
  if (getMobileQuery().matches) {
    return getMobileLeagueStartOffset(leagueMatches)
  }
  const firstUnfinishedMatchIndex = leagueMatches.findIndex(matchesNotFinishedPredicate)
  const lastFinishedMatchIndex = Math.max(0, firstUnfinishedMatchIndex - 1)
  const numVisibleItems = leagueMatches.length - lastFinishedMatchIndex
  let startOffset = lastFinishedMatchIndex
  if (getDesktopWideQuery().matches && numVisibleItems < NUM_VISIBLE_ITEMS_DESKTOP_WIDE) {
    startOffset = Math.max(startOffset - 1, 0)
  }
  return startOffset
}

export class Schedule extends Component {

  get navigationDecorators(){
    return [
      {
        component: ({ previousSlide, }) => createNavigationComponent({
          direction: 'prev',
          caption: t('common.prev'),
          clickHandler: previousSlide,
        }),
        position: 'CenterLeft',
      },
      {
        component: ({ nextSlide, }) => createNavigationComponent({
          direction: 'next',
          caption: t('common.next'),
          clickHandler: nextSlide,
        }),
        position: 'CenterRight',
      },
    ]
  }

  componentWillMount(){
    const {
      IS_INITIALIZED, IS_ENTRY_POINT_MISSING, fetchData, changeNumVisbileItems,
    } = this.props
    if (IS_ENTRY_POINT_MISSING) {
      return getNoEndpointsErrorMessage(this)
    }
    if (IS_INITIALIZED) {
      return true
    }
    fetchData(transformMatchResponseToHomepageSchedule)
    mediaQueryListeners = []
    MEDIA_QUERY_TO_NUM_ITEMS.map(function({ query, items, }){
      const numVisibleItemsChangedListener = changeNumVisbileItems.part(items)
      query.addListener(numVisibleItemsChangedListener)
      mediaQueryListeners.push({ query, numVisibleItemsChangedListener, })
      if (query.matches) {
        numVisibleItemsChangedListener()
      }
    })
    return mediaQueryListeners
  }

  componentWillUnmount(){
    mediaQueryListeners.map(
      ({ query, listener, }) => query.removeListener(listener)
    )
  }

  onLeagueChanged(e){
    const { value: selectedLeague, } = e.target
    this.props.changeLeague(selectedLeague)
  }

  get showMoreButton(){
    const { leagueId, } = this.props
    const showMoreButtonProps = {
      leagueId,
      scoresBaseUrl: getScoresUrl(),
    }
    return <ShowMoreButton { ...showMoreButtonProps } />
  }

  getShowMoreContent(hasMatches){
    return hasMatches ? this.showMoreButton : <div/>
  }

  getMatchContainter(match, key){
    return <MatchContainer { ...{ key, ...match, } }/>
  }

  getMatchesCarousel({ blockName, currentLeagueMatches, offset, }){
    const carouselProps = {
      className: `${ blockName }__carousel`,
      decorators: this.navigationDecorators,
      slidesToShow: this.props.numItems,
      slideIndex: offset,
      children: currentLeagueMatches.map(this.getMatchContainter),
    }
    return <Carousel { ...carouselProps } />
  }

  get noUpcomingMatches(){
    return <NoUpcomingMatches message={ t('home.no_matches') } />
  }

  get leagueSelection(){
    const { leagueName: currentLeague, matches, } = this.props
    const leagueSelectionProps = {
      currentLeague,
      leagues: matches.leagueNamesForSelection,
      onChangeLeagueHandler: this.onLeagueChanged.bind(this),
    }
    return <LeagueSelection { ...leagueSelectionProps } />
  }

  render(){
    const { IS_INITIALIZED, matches, leagueName, } = this.props
    if (!IS_INITIALIZED) {
      return <EmptySchedule />
    }
    const { leagues, } = matches
    const currentLeague = leagues[leagueName]
    const currentLeagueMatches = currentLeague ? currentLeague.matches : []
    const hasMatches = currentLeagueMatches.length !== 0
    const offset = hasMatches ? getLeagueStartOffset(currentLeagueMatches) : 0
    const blockName = 'schedule-component'
    const content = hasMatches ?
      this.getMatchesCarousel({ blockName, currentLeagueMatches, offset, }) :
      this.noUpcomingMatches
    return (
      <div className={ `${ blockName }__container` }>
        <div className={ `${ blockName }__container-wrapper` }>
          { this.leagueSelection }
          <div className={ `${ blockName }__navigation-container` }>{ content }</div>
          { this.getShowMoreContent(hasMatches) }
        </div>
      </div>
    )
  }
}

function mapStateToProps(state){
  const {
    IS_INITIALIZED, matches, leagueName, leagueId, numItems, IS_ENTRY_POINT_MISSING,
  } = state.scheduleComponent
  return {
    IS_INITIALIZED,
    IS_ENTRY_POINT_MISSING,
    matches,
    leagueName,
    leagueId,
    numItems,
  }
}

const ScheduleContainer = {
  name: COMPONENT_NAME,
  stateKey: STATE_KEY,
  component: connect(mapStateToProps, scheduleActions)(Schedule),
  reducer: scheduleReducer,
}

function mountSchedule(){
  return reduxMount({
    [MOUNT_POINTS.SCHEDULE_COMPONENT]: ScheduleContainer,
  })
}


export default function initSchedule(){
  const shouldMountSchedule = isSupportedForDomain(SCHEDULE_FEATURE_ID)
  if (shouldMountSchedule) {
    mountSchedule()
  }
  return shouldMountSchedule
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/schedule/scheduleHomepageContainer.js